import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaEmbalagemResponse } from '../../responses/repositorio-tintas/lista-embalagem.response';

@Injectable({
  providedIn: 'root',
})
export class EmbalagemService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  public listaEmbalagem(idFabricante: number, paginaAtual: number): Observable<ListaEmbalagemResponse> {
    const uri: string = `embalagem/listaEmbalagem/idFabricante/${idFabricante}?paginaAtual=${paginaAtual}`;

    return this.httpClient
      .get<ListaEmbalagemResponse>(environment.urlApiRepositorioTintas + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
